// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"272":"i18n-countries-el-json-0","607":"i18n-countries-en-json-1"}[chunkId] || chunkId) + "." + {"272":"7330fa15","361":"a575b9bc","607":"cf962e54","879":"abe50a40"}[chunkId] + ".chunk.js";
};